import axios from "axios";
import config from "../constants/config";
const XLSX = require("xlsx");

export default {
  methods: {
    async GetAllMasterData () {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$store.dispatch("incident/setMasters", null);
        return false;
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.MASTER_DATA}`
      );
      this.$store.dispatch("incident/setMasters", res.data);

      return true;
    },

    GetStatusMasterName (id) {
      const masters = this.$store.getters["incident/masters"];
      if (!masters && !masters.statusMaster) return "Unavailable";

      const data = masters.statusMaster.find((o) => o.id === id);
      return data ? data.status : "Unavailable";
    },

    GetCategoryMasterName (id) {
      const masters = this.$store.getters["incident/masters"];
      if (!masters && !masters.incidentCategoryMaster) return "Unavailable";

      const data = masters.incidentCategoryMaster.find((o) => o.id == id);
      return data ? data.category_name : "Unavailable";
    },

    GetSubCategoryMasterName (id) {
      const masters = this.$store.getters["incident/masters"];
      if (!masters && !masters.incidentSubCategoryMaster) return "";

      const data = masters.incidentSubCategoryMaster.find((o) => o.id == id);
      return data ? data.sub_category_name : "";
    },

    async GetIncidentMasters () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_MASTER}`
      );

      return res.data;
    },

    async GetAllIncidents ({
      page,
      incidentId,
      filterVehicleNumber,
      fromDate,
      toDate,
      eventCategory,
      vehicleClass,
      minSpeed,
      maxSpeed,
    }) {
      let query = `?page=${page}`;
      if (incidentId) query += `&incidentId=${incidentId}`;
      if (filterVehicleNumber)
        query += `&filterVehicleNumber=${filterVehicleNumber}`;
      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;
      if (eventCategory) query += `&eventCategory=${eventCategory}`;
      if (vehicleClass) query += `&vehicleClass=${vehicleClass}`;
      if (minSpeed || minSpeed === 0) query += `&minSpeed=${minSpeed}`;
      if (maxSpeed) query += `&maxSpeed=${maxSpeed}`;

      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_DETAILS}${query}`
      );

      return res.data;
    },

    async GetAllVsds ({
      page,
      incidentId,
      filterVehicleNumber,
      fromDate,
      toDate,
      eventCategory,
      vehicleClass,
      minSpeed,
      maxSpeed,
      locationIp,
    }) {
      let query = `?page=${page}`;
      if (incidentId) query += `&incidentId=${incidentId}`;
      if (filterVehicleNumber)
        query += `&filterVehicleNumber=${filterVehicleNumber}`;
      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;
      if (eventCategory) query += `&eventCategory=${eventCategory}`;
      if (vehicleClass) query += `&vehicleClass=${vehicleClass}`;
      if (minSpeed || minSpeed === 0) query += `&minSpeed=${minSpeed}`;
      if (maxSpeed) query += `&maxSpeed=${maxSpeed}`;
      if (locationIp) query += `&locationIp=${locationIp}`;

      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VSDS_INCIDENT}${query}`
      );

      return res.data;
    },

    async GetAllVidsIncidents ({
      page,
      category,
      incidentType,
      fromDate,
      toDate,
      packageFilter,
    }) {
      let query = `?page=${page}`;
      if (category) query += `&category=${category}`;
      if (incidentType) query += `&incidentType=${incidentType}`;
      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;
      if (packageFilter) query += `&packageFilter=${packageFilter}`;

      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VIDS_INCIDENT}${query}`
      );

      return res.data;
    },

    async GetVidsFiltersData () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VIDS_INCIDENT_FILTERS}`
      );

      return res.data;
    },

    async GetVsdsFiltersData () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VSDS_INCIDENT_FILTERS}`
      );

      return res.data;
    },

    async GetChallans (page) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.GENERATED_CHALLAN}?page=${page}`
      );
      return res.data;
    },

    async GetRpoIncidens (userId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RPO_INCIDENTS}${userId}`
      );

      return res.data;
    },

    async SaveIncident (incidentBody) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RAISE_INCIDENT}`,
        incidentBody
      );

      return res.data;
    },

    async SaveIncidentImages (formData) {
      const res = await axios({
        method: "post",
        url: `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.UPLOAD_IMAGE}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data;
    },

    async ResolveIncident (resolveBody) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RESOLVE_INCIDENT}`,
        resolveBody
      );

      return res.data;
    },

    async ResolveBulkIncidents () {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RESOLVE_BULK_INCIDENT}`
      );

      return res.data;
    },

    async ResolveSelectedIncidents (incidents) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RESOLVE_SELECTED_INCIDENT}`,
        incidents
      );

      return res.data;
    },

    async GenerateChallan (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RAISE_CHALLAN}`,
        payload
      );
      return res.data;
    },

    async ReportIncident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.REPORT_UPDATE}`,
        body
      );
      return res.data;
    },

    getDateFromCustomDateTime (date) {
      const splitted = date.split("T");
      let d = splitted[0];
      const splitDate = d.split("/");
      return `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;
    },

    convertJsontoExcel (indexDetails, fileName) {
      const ext = ".xlsx";
      const workSheet = XLSX.utils.json_to_sheet(indexDetails);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "incident");
      //generate buffer (larger data)
      XLSX.write(workBook, {
        bookType: "xlsx",
        type: "buffer",
      });
      //binary string
      XLSX.write(workBook, {
        bookType: "xlsx",
        type: "binary",
      });
      XLSX.writeFile(workBook, fileName + ext);
    },

    async GetViolationsData () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VIOLATIONS}`
      );

      return res.data;
    },

    async UpdateVehicleNumber (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VEHICLE_NUMBER}`,
        body
      );
      return res.data;
    },

    async GenerateIncidentReport (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENTS_REPORT}`,
        body
      );
      return res.data;
    },

    async GetReports () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.REPORTS.SHOW_REPORTS}`
      );

      return res.data;
    },

    async GetReportLinks () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.REPORTS.SHOW_REPORT_LINKS}`
      );

      return res.data;
    },

    async ConvertIncidentToAccident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.CONVERT_INCIDENT}`,
        body
      );
      return res.data;
    },

    async ConvertVidsToIncident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.CONVERT_VIDS_TO_INCIDENT}`,
        body
      );
      return res.data;
    },

    async IncidentDetailsById (userId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_DETAILS_BY_ID}${userId}`
      );

      return res.data;
    },

    async GetIncidetForIncidentById (userId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_FOR_INCIDENT_MODULE_BY_ID}${userId}`
      );

      return res.data;
    },

    async AccidentDetailsById (id) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ACCIDENTS.ACCIDENT_BY_ID}${id}`
      );

      return res.data;
    },

    async UpdateAccident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ACCIDENTS.UPDATE_ACCIDENT}`,
        body
      );
      return res.data;
    },

    async ShowVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.SHOW_VEHICLE}`,
        body
      );
      return res.data;
    },

    async AddVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.ADD_VEHICLE}`,
        body
      );
      return res.data;
    },

    async DeleteVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.DELETE_VEHICLE}`,
        body
      );
      return res.data;
    },

    async EditVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.EDIT_VEHICLE}`,
        body
      );
      return res.data;
    },

    async GetRPOUsers () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.GET_RPO_USERS}`
      );
      return res.data;
    },

    async GetEmergencyServices () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.GET_EMERGENCY_SERVICES}`
      );
      return res.data;
    },

    async GetIncidentByTypeID (type, id) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.GET_INCIDENT_BY_TYPE_ID}?type=${type}&id=${id}`
      );
      return res.data;
    },

    async GetAllAccidents ({
      page,
      incidentId,
      filterVehicleNumber,
      fromDate,
      toDate,
    }) {
      let query = `?page=${page}`;
      if (incidentId) query += `&incidentId=${incidentId}`;
      if (filterVehicleNumber)
        query += `&filterVehicleNumber=${filterVehicleNumber}`;
      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;

      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ACCIDENTS.SHOW_ACCIDENTS}${query}`
      );

      return res.data;
    },

    GetChallanFriendlyName (code) {
      switch (code) {
        case "not_generated":
          return "Not Generated";

        case "generated":
          return "Generated";

        default:
          return "NA";
      }
    },

    GetVidsFriendlyEventName (categoryName) {
      switch (categoryName) {
        case "Wrong_Way_Detected":
          return "Wrong Way";

        case "Human_Crossing_Road":
          return "Human Crossing";

        case "Human_Detected":
          return "Human Detected";

        case "Deacceleration_Detected":
          return "Deaccelerated";

        case "Vehicle_Accelerated":
          return "Accelerated";

        case "Reverse_Traffic_Detected":
        case "reverse direction":
          return "Reverse Traffic";

        case "Vehicle_Stopped":
        case "stop":
        case "Stopped_Vehicle_Ended":
          return "Parked Vehicle";

        case "Congestion_Detected":
          return "Traffic Congestion";

        case "slow":
          return "Slow Traffic";

        case "Lane_Changed":
          return "Lane Changed";

        default:
          return null;
      }
    },

    GetVidsFriendlyTypeName (categoryName) {
      switch (categoryName) {
        case "car":
        case "CAR":
        case "LMV":
          return "Car";

        case "truck":
        case "TRUCK":
          return "Truck";

        case "person":
          return "Person";

        case "bus":
          return "Bus";

        case "motorcycle":
        case "TWOWHEELER":
          return "Two Wheeler";

        case "bicycle":
          return "Bicycle";

        case "THREE WHEELER PASSENGER":
          return "Three Wheeler";

        default:
          return null;
      }
    },
  },
};
